module.exports = __webpack_public_path__ + "static/media/open-field-tag-icon.2800fdcd.svg";